import { render, staticRenderFns } from "./APIVersion.vue?vue&type=template&id=1f3b7ea0&"
import script from "./APIVersion.vue?vue&type=script&lang=js&"
export * from "./APIVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports